export const CenteredLayout = ({ page }: any) => {
  return (
    <div className="flex h-full flex-1 flex-col items-center justify-center">
      <div className="fixed inset-0 -z-10">
        <img src="/bkgnd-min.png" alt="background" className="h-full w-full object-cover" />
      </div>
      {page}
    </div>
  );
};

export default CenteredLayout;

